<script>
import linq from 'linq'
import ProductDetailViewModel from '../../viewModel/ProductDetailViewModel'
import Size from '../../models/Size'
import ItemImage from '../../models/ItemImage'
import ProductModal from './ProductModal.vue'
import { addCartItem, getItems } from '../../services/CartService'

const TABLE_CLOTHES = 141

export default {
    name: 'product-detail',

    data() {
        return {
            loading: false,
            colorActive: this.getQueryString().color_id || 0,
            sizes: [],
            vm: new ProductDetailViewModel(),
            busy: false,
            colorName: '',
            message: '',
            product: null,
            showModal: false,
            imgName: null,
            itemCodes: [],
            buttonState: false,
            isShowGuide: false,
        }
    },

    props: {
        data: {},
    },

    computed: {
        allCartDisabled() {
            return linq.from(this.sizes).any((x) => x.active)
        },

        allocateMessage() {
            return this.vm.hasSubs ? 'サイズ' : 'アイテム'
        },

        baseUrl() {
            let url = ''
            if (window.location.search) {
                url = window.location.href.slice(0, window.location.href.indexOf('?'))
            } else {
                url = window.location.href
            }
            return url + '?color_id=' + this.colorActive
        },

        createEmail() {
            const base = 'mailto:?subject=partycreationでこの商品をチェック&body='
            return `${base}${this.vm.name}  ${this.colorName}%0D%0A ${this.baseUrl}`
        },
    },

    watch: {
        async 'vm.images'(n, o) {
            if (!n) return
            await this.$nextTick()

            Vue$(`#product-zoom${this.vm.images.normal_size[0].id}`).xzoom({
                zoomWidth: $(window).width() >= 1200 ? 400 : 'auto',
                title: true,
                tint: '#fff',
                tintOpacity: 0.4,
                Xoffset: 5,
                Yoffset: 5,
                scroll: false,
                defaultScale: 0.3,
            })
            const self = this

            $('.product-gallery')
                .find('a')
                .on('click', function (e) {
                    var previewImg = $(this).data('image'),
                        originalImg = $(this).data('zoom-image')

                    $(`#product-zoom${self.vm.images.normal_size[0].id}`)
                        .attr('src', previewImg)
                        .attr('data-xoriginal', originalImg)

                    e.preventDefault()
                })

            $.each($('.owl-data-carousel'), function (index) {
                var settings = {
                        loop: false,
                        margin: 30,
                        navText: [],
                        nav: false,
                        dots: false,
                        lazyLoad: true,
                        items: 1,
                        autoHeight: false,
                        responsive: {
                            0: {
                                items: 1,
                            },
                            480: {
                                items: 2,
                            },
                            768: {
                                items: 3,
                            },
                            992: {
                                items: 4,
                            },
                        },
                        rtl: $('html').attr('dir') === 'rtl' ? true : false,
                    },
                    owlsettings,
                    owlResponsive
                ;(owlsettings = $(this).data('owl-settings')),
                    (owlResponsive = $(this).data('owl-responsive'))

                // If it is not object don't use new settings - data-owl-settings
                if (typeof owlsettings === 'object') {
                    settings = $.extend(true, {}, settings, owlsettings)
                }

                // If it is not object don't use responsive setting
                if (typeof owlResponsive === 'object') {
                    settings = $.extend(true, {}, settings, {
                        responsive: owlResponsive,
                    })
                }

                // Clear if items:1 is set and there is no data-owl-responsive
                if (typeof owlResponsive === 'undefined' && owlsettings.items <= 2) {
                    settings.responsive = {}
                }

                $(this).owlCarousel(settings)
            })
        },
    },

    created() {
        this.vm.create(eval(this.data))
        const categories = linq
            .from(this.vm.product.categories)
            .where((x) => x.id === TABLE_CLOTHES)
            .toArray()
        this.isShowGuide = !!categories.length

        this.sizeChange(this.vm.id, this.colorActive)
    },

    async mounted() {},

    methods: {
        async sizeChange(productId, index) {
            index = Number(index)
            const color = linq
                .from(this.vm.mains)
                .firstOrDefault((x) => x.id === index, linq.from(this.vm.mains).first())

            const any = this.vm.hasSubs ? color : this.vm.subs[index]
            this.colorName = any.name
            this.colorActive = index || color.id
            if (any._model === 'Color') {
                this.vm.subs = []
                this.sizes = []
            }
            this.vm.images = null

            axios.get(`/api/product/${productId}/image/${any.id}`).then(async (x) => {
                let images = linq
                    .from(x.data)
                    .select((x) => new ItemImage(x))
                    .toArray()
                if (!images.length) {
                    images = [new ItemImage()]
                }
                this.vm.images = this.vm.createImage(images)
                this.imgName = this.vm.images.normal_size[0].imgName
            })

            if (this.sizes.length && !this.vm.hasSubs) return
            this.busy = true
            const colorId = color.id
            const { data } = await axios.get(`/api/product/${productId}/size/${colorId}`)
            this.buttonState = !!data.favorite_status
            linq.from(data.data)
                .select((x) => {
                    let data = x.size
                    data.item_id = x.item_id
                    data.price_jpy = x.price_jpy
                    data.count = 0
                    data.active = false
                    this.sizes.push(data)
                })
                .toArray()
            this.itemCodes = data.data

            this.busy = false
            this.setMessage('')
        },

        async addCartMulti() {
            this.busy = true
            this.setMessage('')

            let items = linq
                .from(this.sizes)
                .where((x) => x.active)
                .where((x) => x.count)
                .toArray()

            const is_success = await addCartItem(items)

            // カウントを０に戻す
            linq.from(this.sizes)
                .select((x) => (x.count = 0))
                .toArray()

            if (is_success) {
                this.setMessage('カートを更新しました')
                this.addCartAction()
            }
            this.busy = false
        },

        async addCart(size) {
            this.busy = true
            this.setMessage('')

            const items = [size]
            const is_success = await addCartItem(items)
            size.count = 0

            if (is_success) {
                this.setMessage('カートを更新しました')
                this.addCartAction()
            }
            this.busy = false
        },

        addCartAction() {
            window.cartDrop.$emit('getCartItems')
        },

        setMessage(message = '') {
            this.message = message
        },

        async showProductModal(product) {
            this.showModal = true
            this.product = product
        },

        changeImageName(index) {
            this.imgName = null
            this.imgName = this.vm.images.normal_size[index].imgName
        },

        getQueryString() {
            let vars = [],
                max = 0,
                hash = '',
                array = ''
            const url = window.location.search

            //?を取り除くため、1から始める。複数のクエリ文字列に対応するため、&で区切る
            hash = url.slice(1).split('&')
            max = hash.length
            for (var i = 0; i < max; i++) {
                array = hash[i].split('=') //keyと値に分割。
                vars.push(array[0]) //末尾にクエリ文字列のkeyを挿入。
                vars[array[0]] = array[1] //先ほど確保したkeyに、値を代入。
            }
            return vars
        },

        async favorite(productId) {
            this.busy = true
            this.setMessage('')

            await axios
                .post(`/api/product/change-favorite`, {
                    'product_id': productId,
                    'color_id': this.colorActive,
                })
                .then((res) => {
                    this.buttonState = res.data.status
                    this.setMessage('お気に入りに追加しました')
                    if (!this.buttonState) {
                        this.setMessage('お気に入りを解除しました')
                    }
                    this.busy = false
                })

                .catch((error) => {
                    console.log(error.response)
                    this.busy = false
                })
        },

        copy() {
            navigator.clipboard.writeText(this.baseUrl)
            this.setMessage('コピーしました')
        },
    },

    components: {
        ProductModal,
    },
}
</script>

<style lang="scss" scoped>
#product-detail {
    #zoomer-pane-container {
        top: 0 !important;
        left: 470px !important;
    }

    .pane-container {
        opacity: 1;
        @media screen and (max-width: 768px) {
            display: none;
            opacity: 0;
        }
    }

    .product-details {
        position: relative;
        padding-right: 0;

        .product-label {
            display: -ms-flexbox;
            display: flex;
            font-weight: bold;

            label {
                font-weight: bold;

                &:nth-child(1) {
                    margin-right: 55px;
                    @media screen and (max-width: 991px) {
                        margin-right: 140px;
                    }
                    @media screen and (max-width: 576px) {
                        margin-right: 40px;
                    }
                }

                &:nth-child(2) {
                    margin-right: 30px;
                    @media screen and (max-width: 991px) {
                        margin-right: 85px;
                    }
                    @media screen and (max-width: 576px) {
                        margin-right: 70px;
                    }
                }
            }
        }

        .filter-sub li {
            font-size: inherit;

            span {
                padding: 0 10px;
                width: auto;
                text-align: center;
                display: block;
            }
        }

        .filter-size-list {
            //overflow-y: scroll;
            //overflow-x: hidden;
            //max-height: 275px;
            //padding-right: 15px;
            @media screen and (max-width: 576px) {
                padding-right: 0;
            }

            li {
                width: 100%;
                border-bottom: 1px solid #dfdfdf;
                padding-bottom: 5px;
                margin-right: 0;
                margin-top: 5px;
                margin-bottom: 5px;

                .item {
                    margin-right: 15px;
                    width: 23%;
                    @media screen and (max-width: 576px) {
                        width: 18%;
                        margin-right: 12px;
                    }
                }

                .item.rentalBtn {
                    @media screen and (max-width: 576px) {
                        width: 22%;
                    }
                }

                .filter-size-name {
                    font-size: 13px;
                    color: #000;
                    @media screen and (max-width: 576px) {
                        min-width: 40px;
                    }
                }

                .count-box {
                    position: relative;
                    display: inline-block;
                    -ms-flex: 0 0 auto;
                    -webkit-box-flex: 0;
                    flex: 0 0 auto;
                    margin-right: 30px;
                    padding-right: 32px;

                    .item-count {
                        height: 50px;
                        width: 77px;
                        margin-bottom: 0;
                        text-align: center;
                        border-color: #dfdfdf;
                        border-radius: 0;
                        font-size: 14px;
                        font-weight: 700;
                        color: #262634;
                        font-family: 'Oswald', sans-serif;
                        padding: 21px 15px 18px;
                    }
                }

                .product-price {
                    font-size: 17px;
                    color: #000;
                    //margin-left: 10px;
                }

                button {
                    width: 100%;
                    flex: unset;
                    font-weight: bold;
                    font-size: 10px;
                    padding: 10px 6px;
                    @media screen and (max-width: 1127px) {
                        font-size: 11px;
                        padding: 7px 4px 7px;
                    }
                    @media screen and (max-width: 576px) {
                        padding: 10px;
                    }
                }

                .product-quantity-item {
                    width: 15%;
                    position: relative;
                    display: inline-block;
                    -ms-flex: 0 0 auto;
                    flex: 0 0 auto;
                    //margin-right: 30px;
                    padding-right: 0;

                    input {
                        margin-bottom: 0;
                        width: 100%;
                        height: 50px;
                        text-align: center;
                        border: 1px solid #dfdfdf;
                        font-size: 14px;
                        font-weight: 700;
                        color: #262634;
                        font-family: 'Oswald', sans-serif;
                        padding: 14px 15px 14px;
                    }
                }

                .input-group-btn-vertical {
                    button {
                        position: absolute;
                        left: 100%;
                        margin: 0 0 0 4px;
                        width: 25px;
                        height: 25px;
                        padding: 0;
                        color: #262634;
                        font-size: 10px;
                        text-align: center;
                        border: 1px solid #dfdfdf;
                        background-color: #fff;

                        &:hover {
                            color: #fff;
                            border-color: #262634;
                            background-color: #262634;
                        }
                    }

                    .btn-up {
                        top: 0;
                    }

                    .btn-down {
                        top: 26px;
                    }
                }
            }
        }

        .btn-alltobag {
            justify-content: flex-end;
            display: flex;
            z-index: 0;
            @media screen and (max-width: 576px) {
                flex-wrap: wrap;
                -webkit-flex-wrap: wrap;
            }

            button {
                background-color: #fff;
                color: #000;
                text-align: right;
                font-weight: bold;

                &:hover {
                    color: #fff;
                    border-color: #262634;
                    background-color: #262634;
                }
            }
        }
    }

    .product-detail-rule {
        display: flex;
        flex-wrap: wrap;
    }

    .productIcons {
        padding-top: 15px;
        display: flex;
        flex-wrap: wrap;
        margin-right: -5px;
        margin-left: -5px;

        .col {
            padding: 0 5px;
            margin-bottom: 15px;

            img {
                width: 115px;
                height: 115px;
            }
        }
    }

    .sizeGuide {
        .title {
            font-weight: bold;
            font-size: 16px;
            padding-left: 8px;
            margin-bottom: 16px;
            border-left: 5px solid #cccccc;
            line-height: 1.2;
        }

        li {
            font-weight: bold;
            font-size: 14px;
            background: #cccccc;
            margin-bottom: 1px;
            padding: 3px 8px;
            width: 260px;
            a {
                display: block;
            }
        }

        img {
            display: block;
            max-width: 300px;
            margin: auto;
            width: 100%;
            object-fit: contain;
        }
    }
}

.owl-carousel .owl-item img {
    height: 100%;
    object-fit: cover;
}

.heart_color {
    color: #dfdfdf;
}

.heart_color:hover {
    opacity: .8;
    cursor: pointer;
}

.favorite {
    color: lightcoral;
}

.share-buttons {
    display: flex;
    column-gap: 20px;

    i {
        font-size: 36px;
    }

    .facebook {
        i {
            color: #3b5998;
        }
    }

    .line {
        i {
            color: #06c755;
        }
    }

    .copy {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/products/ProductDetail.vue